import api from "./api";

const CART_KEY = "kanama_grocery_cart_v1";

export function loadCart() {
  try {
    const raw = localStorage.getItem(CART_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveCart(items) {
  try {
    localStorage.setItem(CART_KEY, JSON.stringify(items));
    window.dispatchEvent(new Event("kanama-cart-changed"));
  } catch {
    /* ignore */
  }
}

export function addToCart(product, quantity = 1) {
  const cart = loadCart();
  const idx = cart.findIndex((c) => c.product_id === product.id);
  if (idx >= 0) {
    cart[idx].quantity = Math.min(99, cart[idx].quantity + quantity);
  } else {
    cart.push({
      product_id: product.id,
      name: product.name,
      unit: product.unit,
      price_xaf: product.price_xaf,
      shop_id: product.shop_id,
      image_url: product.image_url || "",
      quantity,
    });
  }
  saveCart(cart);
  return cart;
}

export function updateCartQty(productId, quantity) {
  const cart = loadCart();
  const idx = cart.findIndex((c) => c.product_id === productId);
  if (idx < 0) return cart;
  if (quantity <= 0) cart.splice(idx, 1);
  else cart[idx].quantity = Math.min(99, quantity);
  saveCart(cart);
  return cart;
}

export function removeFromCart(productId) {
  const cart = loadCart().filter((c) => c.product_id !== productId);
  saveCart(cart);
  return cart;
}

export function clearCart() {
  saveCart([]);
}

export function cartTotals(cart) {
  const items = cart || loadCart();
  const count = items.reduce((s, c) => s + c.quantity, 0);
  const subtotal = items.reduce((s, c) => s + c.quantity * c.price_xaf, 0);
  return { count, subtotal_xaf: subtotal };
}

export function formatXAF(amount) {
  if (amount == null || isNaN(amount)) return "0 FCFA";
  return `${Math.round(amount).toLocaleString("fr-FR")} FCFA`;
}

// API helpers
export const grocery = {
  categories: () => api.get("/grocery/categories").then((r) => r.data),
  zones: () => api.get("/grocery/zones").then((r) => r.data),
  shops: (params = {}) => api.get("/grocery/shops", { params }).then((r) => r.data),
  shop: (id) => api.get(`/grocery/shops/${id}`).then((r) => r.data),
  products: (params = {}) => api.get("/grocery/products", { params }).then((r) => r.data),
  estimate: (payload) => api.post("/grocery/checkout/estimate", payload).then((r) => r.data),
  checkout: (payload) => api.post("/grocery/checkout", payload).then((r) => r.data),
  confirmSandbox: (paymentId, otp) =>
    api.post(`/grocery/payments/${paymentId}/confirm-sandbox`, { otp }).then((r) => r.data),
  myOrders: () => api.get("/grocery/orders/me").then((r) => r.data),
  order: (id) => api.get(`/grocery/orders/${id}`).then((r) => r.data),
  // admin
  adminShops: () => api.get("/grocery/admin/shops").then((r) => r.data),
  adminCreateShop: (payload) => api.post("/grocery/admin/shops", payload).then((r) => r.data),
  adminUpdateShop: (id, payload) => api.put(`/grocery/admin/shops/${id}`, payload).then((r) => r.data),
  adminDeleteShop: (id) => api.delete(`/grocery/admin/shops/${id}`).then((r) => r.data),
  adminCreateProduct: (payload) => api.post("/grocery/admin/products", payload).then((r) => r.data),
  adminUpdateProduct: (id, payload) => api.put(`/grocery/admin/products/${id}`, payload).then((r) => r.data),
  adminDeleteProduct: (id) => api.delete(`/grocery/admin/products/${id}`).then((r) => r.data),
  adminOrders: () => api.get("/grocery/admin/orders").then((r) => r.data),
  adminUpdateZone: (slug, payload) => api.put(`/grocery/admin/zones/${slug}`, payload).then((r) => r.data),
};
